import { lazy } from 'react';

const SsoDashboardPage = lazy(() =>
  import('./page.js').then((module) => ({ default: module.SsoDashboardPage })),
);
const SsoConnectionDetailPage = lazy(() =>
  import('./[id]/page.js').then((module) => ({ default: module.SsoConnectionDetailPage })),
);

export { SsoConnectionDetailPage, SsoDashboardPage };
